import { GridLegacy, IconButton, Menu, MenuItem } from "@mui/material";
import React from "react";
import conditionContainsIcon from "../../../../../../static/images/icons/condition-contains.png";
import conditionEqualIcon from "../../../../../../static/images/icons/condition-equal.png";
import conditionFilledIcon from "../../../../../../static/images/icons/condition-filled.png";
import conditionGreaterIcon from "../../../../../../static/images/icons/condition-greater.png";
import conditionGreaterOrEqualIcon from "../../../../../../static/images/icons/condition-greater-or-equal.png";
import conditionLessIcon from "../../../../../../static/images/icons/condition-less.png";
import conditionLessOrEqualIcon from "../../../../../../static/images/icons/condition-less-or-equal.png";
import conditionNotContainsIcon from "../../../../../../static/images/icons/condition-not-contains.png";
import conditionNotEqualIcon from "../../../../../../static/images/icons/condition-not-equal.png";
import conditionNotFilledIcon from "../../../../../../static/images/icons/condition-not-filled.png";
import conditionNotStartsWithIcon from "../../../../../../static/images/icons/condition-not-starts-with.png";
import conditionStartsWithIcon from "../../../../../../static/images/icons/condition-starts-with.png";

const ConditionsValues = [
  "Равно",
  "Не равно",
  "Больше",
  "Меньше",
  "Больше или равно",
  "Меньше или равно",
  "Содержит",
  "Не содержит",
  "Начинается на",
  "Не начинается на",
  "Заполнено",
  "Не заполнено",
];

const ConditionsImage = [
  conditionEqualIcon,
  conditionNotEqualIcon,
  conditionGreaterIcon,
  conditionLessIcon,
  conditionGreaterOrEqualIcon,
  conditionLessOrEqualIcon,
  conditionContainsIcon,
  conditionNotContainsIcon,
  conditionStartsWithIcon,
  conditionNotStartsWithIcon,
  conditionFilledIcon,
  conditionNotFilledIcon,
];

export default function ConditionButton(props) {
  const [value, setValue] = React.useState(Number(props.condition) - 1);
  const [items, setItems] = React.useState([]);

  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setItems(getItems(props.conditions));
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const clickMenuItem = (ev) => {
    const item = ev.target.closest("li");
    if (item) {
      setValue(item.dataset.index);
      if (props.paramsBoxRef && props.paramsBoxRef.current) {
        const record = props.paramsBoxRef.current.querySelector(`#${props.recID}`);
        if (record) {
          record.dataset.condition = Number(item.dataset.index) + 1;
          if (props.onEdit) {
            props.onEdit({
              record: record,
              Condition: Number(item.dataset.index) + 1,
              textchanged: "0",
            });
          }
        }
      }
    }
    handleClose();
  };

  React.useEffect(() => {}, []);

  function getItems(conditions) {
    const result = [];
    for (let i = 0; Math.pow(2, i) < conditions; i++) {
      if (Math.pow(2, i) & conditions) {
        result.push(
          <MenuItem key={`item-condition_${i}`} onClick={clickMenuItem} data-index={i}>
            <GridLegacy container direction="row" justifyContent="flex-start" alignItems="center">
              <GridLegacy
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <img src={ConditionsImage[i]} />
              </GridLegacy>
              <GridLegacy style={{ paddingLeft: "5px" }}>{ConditionsValues[i]}</GridLegacy>
            </GridLegacy>
          </MenuItem>,
        );
      }
    }
    return result;
  }

  return (
    <>
      <IconButton
        style={{
          height: "18px",
          width: "18px",
          display: props.visible ? "flex" : "none",
          fontSize: "100%",
          justifyContent: "center",
          alignItems: "center",
        }}
        id="basic-button"
        aria-controls={open ? "basic-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        onClick={handleClick}
      >
        <img src={ConditionsImage[value]} />
      </IconButton>
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        slotProps={{
          list: {
            "aria-labelledby": "basic-button",
          },
        }}
      >
        {items}
      </Menu>
    </>
  );
}
